module.exports = __webpack_public_path__ + "static/media/necklace.c8056ee2.png";